<template>
  <div>
    <router-link :to="{name: 'details'}">
      <div
        :gutter="20"
        class="my-purchases-row">
        <el-col
          :xs="4"
          :sm="2"
          :md="1"
          :lg="1"
          :xl="1"
          class="icon-category">
          <img
            src="/static/images/arts-icon.svg"
            alt="icon-category">
        </el-col>
        <el-col
          :xs="24"
          :sm="12"
          :md="11"
          :lg="11"
          :xl="11"
          class="name-event">
          <span>Cirque Du Soleil: Totem</span>
        </el-col>
        <el-col
          :xs="24"
          :sm="5"
          :md="5"
          :lg="5"
          :xl="5"
          :span="5"
          class="date-event">
          <span>10 de Septiembre de 2018</span>
        </el-col>
        <el-col
          :span="3"
          class="price-event hidden-xs-only">
          $220,000,000
        </el-col>
        <el-col
          :span="3"
          class="status-event hidden-xs-only">
          <i class="icon-check-icon"/>
          <span>Pagado</span>
        </el-col>
        <el-col
          :span="3"
          class="status-event hidden-sm-and-up">
          <i class="icon-check-icon"/>
        </el-col>
        <el-col
          :xs="24"
          :sm="2"
          :md="1"
          :lg="1"
          :xl="1"
          class="link-event hidden-xs-only">
          <i class="icon-chevron-right"/>
        </el-col>
      </div>
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'MtMyPurchasesRow'
}
</script>

<style lang="scss" scoped>

.my-purchases-row{
  background-color: white;
  height: 50px;
  display: flex;
  align-items: center;
  margin-bottom: 3px;
  cursor: pointer;
  transition: all .3s ease-in-out;
  @media #{$iPhone} {
    height: auto !important;
  }
  &:hover{
    -webkit-box-shadow: 0 5px 6px 0 rgba(0,0,0,0.1);
    -moz-box-shadow: 0 5px 6px 0 rgba(0,0,0,0.1);
    box-shadow: 0 5px 6px 0 rgba(0,0,0,0.1);
    transform: scale(1.001);
  }
}

.icon-category {
  text-align: center;
  min-width: 4.16667% !important;
  img {
    width: 26px;
    height: 26px;
  }
}

.name-event {
  span {
    @include font-primary(12px, semibold);
    color: $carbon
  }
}
.status-event{
  i{
    color: $available;
  }
}

  .link-event{
    height: 50px;
    line-height: 50px;
    text-align: center;
    border-left: 1px solid #F5F5F5;
    i{
      color: $roseHeader;
      font-weight: bold;
    }
    &:hover{
      i{
        color: $roseActive;
      }
    }
  }

  a{
    text-decoration: none;
    color: $carbon;
  }
</style>



// WEBPACK FOOTER //
// src/components/_shared/mt-my-purchases-row.vue